/* ==========================================================================
   ZWANZE — newsletter-popup.js
   La fenetre d'inscription, et surtout les regles qui l'empechent de sortir.

   LE DELAI COMPTE LE TEMPS REGARDE, PAS LE TEMPS ECOULE
   Un minuteur lance au chargement se declenche aussi pour l'onglet ouvert en
   arriere-plan puis oublie : le visiteur revient une demi-heure plus tard et
   trouve une fenetre deja la, sans savoir pourquoi. Ici le compteur s'arrete
   des que l'onglet passe en arriere-plan et reprend au retour.

   UNE FERMETURE EST UNE REPONSE
   Elle est retenue pour le nombre de jours regle par le marchand. Une adresse
   laissee, elle, desactive la fenetre definitivement — et le temoin est
   partage avec le champ email du panier : donner son adresse a un endroit
   vaut pour les deux.
   ========================================================================== */
(function () {
  'use strict';

  var Z = window.Zwanze;
  var root = document.querySelector('z-newsletter-popup');
  if (!root || !Z || !Z.Panel) return;

  var CLE = 'zwanze:newsletter';

  function lire() {
    try { return JSON.parse(localStorage.getItem(CLE)) || {}; }
    catch (e) { return {}; }
  }
  function ecrire(patch) {
    var s = lire();
    for (var k in patch) s[k] = patch[k];
    try { localStorage.setItem(CLE, JSON.stringify(s)); } catch (e) { /* navigation privee */ }
  }

  function interdite() {
    var s = lire();
    if (s.inscrit) return 'deja inscrit';
    if (root.dataset.skipCart === 'true' && root.dataset.page === 'cart') return 'page panier';
    if (s.ferme) {
      var jours = parseFloat(root.dataset.again || '30');
      if (Date.now() - s.ferme < jours * 86400000) return 'fermee recemment';
    }
    return null;
  }

  class Popup extends Z.Panel {
    connectedCallback() {
      super.connectedCallback();

      var raison = interdite();
      if (raison) return;

      this._vu = 0;
      this._depart = document.hidden ? null : Date.now();
      this._seuil = parseFloat(this.dataset.delay || '30') * 1000;

      this._tick = window.setInterval(this._compte.bind(this), 1000);
      document.addEventListener('visibilitychange', this._visibilite.bind(this));

      this.addEventListener('submit', this._envoi.bind(this));
      var copie = this.querySelector('[data-nlp-copy]');
      if (copie) copie.addEventListener('click', this._copie.bind(this));
    }

    _visibilite() {
      if (document.hidden) {
        this._compte();
        this._depart = null;
      } else if (this._depart === null) {
        this._depart = Date.now();
      }
    }

    _compte() {
      if (this._depart !== null) {
        this._vu += Date.now() - this._depart;
        this._depart = Date.now();
      }
      if (this._vu < this._seuil) return;

      window.clearInterval(this._tick);
      this._tick = null;

      // Un autre panneau ouvert veut dire que le visiteur est occupe :
      // on repasse plus tard plutot que de lui couper la parole.
      if (document.querySelector('z-cart-drawer[open], z-mobile-nav[open], [data-panel][open]')) {
        this._tick = window.setInterval(this._compte.bind(this), 2000);
        return;
      }
      if (interdite()) return;

      this.hidden = false;
      // Le retrait de [hidden] et l'ouverture doivent tomber sur deux images
      // successives, sinon la transition d'entree ne joue pas.
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(this.open.bind(this));
      }.bind(this));
    }

    close() {
      var etait = this.hasAttribute('open');
      super.close();
      if (etait && !lire().inscrit) ecrire({ ferme: Date.now() });
      window.setTimeout(function () {
        if (!this.hasAttribute('open')) this.hidden = true;
      }.bind(this), 280);
    }

    _envoi(event) {
      var form = event.target.closest('.z-nlp__form');
      if (!form) return;
      event.preventDefault();

      var champ = form.querySelector('input[type="email"]');
      if (!champ || !champ.checkValidity()) { if (champ) champ.reportValidity(); return; }

      this.setAttribute('data-busy', 'true');
      fetch(form.getAttribute('action') || '/contact', {
        method: 'POST', body: new FormData(form), headers: { Accept: 'text/html' }
      }).catch(function () {
        /* Reseau coupe : on montre quand meme le code. Le faire retaper ne
           reparerait rien et lui ferait perdre l'offre annoncee. */
      }).then(function () {
        this.removeAttribute('data-busy');
        this.setAttribute('data-done', '');
        ecrire({ inscrit: Date.now() });
        var done = this.querySelector('[data-nlp-done]');
        if (Z.announce && done) Z.announce(done.textContent.trim());
      }.bind(this));
    }

    _copie(event) {
      var btn = event.currentTarget;
      var etiquette = btn.querySelector('[data-nlp-copy-label]');
      var texte = btn.dataset.code || '';
      var fini = function (ok) {
        if (!etiquette) return;
        var avant = etiquette.textContent;
        etiquette.textContent = ok ? '✓' : texte;
        window.setTimeout(function () { etiquette.textContent = avant; }, 1600);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(texte).then(function () { fini(true); }, function () { fini(false); });
      } else {
        fini(false);
      }
    }
  }

  if (!customElements.get('z-newsletter-popup')) customElements.define('z-newsletter-popup', Popup);

  /* Le champ email du panier alimente le meme temoin : une adresse laissee
     la-bas doit empecher la fenetre de sortir ensuite. */
  document.addEventListener('submit', function (event) {
    if (event.target.closest('.z-cartmail__form')) ecrire({ inscrit: Date.now() });
  }, true);
})();
